import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ScrollToTop from 'components/scroll-to-top';

import Demo from './component';

import 'pages/products/style.css';


class DemoHeader extends React.PureComponent {
  render() {
    return (
      <div className="l-product-page">
        <ScrollToTop />
        <header className="demo-header">
          <h1>
            Air quality forecast service
          </h1>
          <div className="demo-button">
            <Link className="c-button demo-page-btn -large" to="/products/forecast-system/">Close demo</Link>
          </div>
        </header>
        <Demo />
      </div>
    );
  }
}

DemoHeader.propTypes = {
  history: PropTypes.shape({ replace: PropTypes.func }).isRequired,
  match: PropTypes.shape({ params: PropTypes.object }).isRequired,
};

export default DemoHeader;



// WEBPACK FOOTER //
// ./src/pages/products/forecast/demo/index.js